import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useAppSelector } from 'hooks/useAppStore';
import { TopNav } from 'components/navigation/TopNav';
import { MarketingNav } from 'features/marketing/components/MarketingNav';
import { PageTransition } from 'components/ui/PageTransition';
import { SiteFooter } from 'components/layout/SiteFooter';
import { getSchoolTheme, applySchoolTheme, defaultSchoolTheme } from 'theme/schoolThemes';

export function PublicLayout() {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);

  return (
    <div className="flex min-h-screen flex-col">
      {isAuthenticated ? <TopNav /> : <MarketingNav />}
      <main className="flex-1">
        <PageTransition>
          <Outlet />
        </PageTransition>
      </main>
      <SiteFooter />
    </div>
  );
}

export function SchoolThemeProvider({ children }: { children: React.ReactNode }) {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    const theme = slug ? getSchoolTheme(slug) : defaultSchoolTheme;
    applySchoolTheme(theme);
    return () => applySchoolTheme(defaultSchoolTheme);
  }, [slug]);

  return <>{children}</>;
}
